// extracted by mini-css-extract-plugin
export default {"contents":"FG-z","sectionHeading":"GG-z"};